<div fxLayout="row" fxLayoutAlign="start center">
  <p class="rating">{{ rating }}</p>
  <app-star-rating
    class="evaluation-star-rating"
    matTooltip="{{ getExactRating() }}"
    matTooltipPosition="right"
    matTooltipShowDelay="500"
    [rating]="rating"
    [readOnly]="true"
  ></app-star-rating>
</div>
